<template>
    <AuthLayout>
        <form @submit.prevent="submit">

            <h2 class="font-bold text-lg mb-4">{{ __('admins::auth.forgot_password_title') }}</h2>

            <div v-if="$page.props.flash.success" class="text-green-700">
                {{ $page.props.flash.success }}
            </div>

            <div v-else>
                <FormGroup :label="__('admin::labels.email')" :error="errors.email">
                    <Input name="email" type="email" :has-error="exists(errors.email)" v-model="form.email" :required="true" autocomplete="username" autofocus />
                </FormGroup>

                <div class="flex items-center justify-end mt-2">
                    <Button :block="true" :loading="form.processing" class="!py-3">
                        {{ __('admin::auth.request_reset_password') }}
                    </Button>
                </div>

                <div class="flex justify-center mt-6">
                    <InertiaLink :href="$route('admin::auth.create')" class="flex items-center gap-2 text-gray-500 text-sm">
                        <ArrowNarrowLeftIcon class="w-4 h-4" />
                        {{ __('admin::auth.login_link') }}
                    </InertiaLink>
                </div>
            </div>
        </form>
    </AuthLayout>
</template>

<script>
import {ArrowNarrowLeftIcon} from "@heroicons/vue/solid";

export default {
    components: {
        ArrowNarrowLeftIcon,
    },
    props: {
        errors: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                email: '',
            })
        }
    },

    methods: {
        submit() {
            this.form.post(this.$route('admin::forgot-password.submit'));
        }
    }
}
</script>
